import "../../styles/layouts/QuizzPage.scss";
import Quizz from "../../components/Quizz/Quizz";

const QuizzPage = (): React.JSX.Element => {
  return (
    <div>
      <Quizz></Quizz>
    </div>
  );
};
export default QuizzPage;
